import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Upload, Drawer, Select, Table, Checkbox } from 'antd';
import { PlusOutlined, EditFilled, PlusCircleFilled, CloseOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { v4 as uuidv4 } from 'uuid';
import constants, { H3_TITLE, CountryCodes } from '@Apis/constants';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import AddressActions from '@Actions/addressActions';
import TenantActions from '@Actions/tenantActions';
import UserActions from '@Actions/userActions';
import H3Text from '@Uilib/h3Text';
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';
import Helpers from '@Apis/helpers';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TextArea from 'antd/es/input/TextArea';
import H3ImageSelectorWithCrop from '@Uilib/H3ImageSelectorWithCrop';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';

const colorConfig = [{
  color: '#E1AE00',
  name: 'Amber',
},
{
  color: '#2D7DF7',
  name: 'Blue',
},
{
  color: '#27A52C',
  name: 'Green',
},
{
  color: '#2942D1',
  name: 'Indigo',
},
{
  color: '#EC6800',
  name: 'Orange',
},
{
  color: '#00947C',
  name: 'Teal',
},
{
  color: '#7A7A7A',
  name: 'Grey',
},
{
  color: '#E41D0F',
  name: 'Red',
},
];

const { Option } = Select;
/**
 *
 */

const button = (
  <div>
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>

  </div>
);

function BusinessProfile({
  user, getAddresses, getTenants, getTenantsConfiguration, tenants, tenantsConfiguration, updateTenant, updateTenantConfiguration, getTenantsSuccess, getTenantsConfigurationSuccess, getUserProfile, getTenantsLoading, updateTenantLoading, getTenantsConfigurationLoading, updateTenantConfigurationLoading,
}) {
  const [showAddressDrawer, setShowAddressDrawer] = useState(false);
  const [selectedAddressType, setSelectedAddressType] = useState('');
  const [fileList, setFileList] = useState([]);
  const [qrCode, setQRCode] = useState([]);
  const [email, setEmail] = useState([]);
  const [countryCode, setCountryCode] = useState('');
  const [phone, setPhone] = useState('');
  const [gst, setGst] = useState('');
  const [branchCode, setBranchCode] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [shippingAddress, setShippingAddress] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyLegalName, setCompanyLegalName] = useState('');
  const [defaultProductionDept, setDefaultProductionDept] = useState(null);
  const [defaultSalesDept, setDefaultSalesDept] = useState(null);
  const [defaultRmDept, setDefaultRmDept] = useState(null);
  const [defaultFgDept, setDefaultFgDept] = useState(null);
  const [defaultBpDept, setDefaultBpDept] = useState(null);
  const [color, setColor] = useState('#2d7dF7');
  const [defaultTerms, setDefaultTerms] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isUserReady, setIsUserReady] = useState(false);
  const [bankDetails, setBankDetails] = useState('');
  const [emailName, setEmailName] = useState('');
  const [ciData, setCIData] = useState([]);
  const [entityConfiguration, setEntityConfiguration] = useState();

  /**
   * Fetches addresses for the user with tenant ID and type 'TENANT' on component mount
   * and updates the isUserReady state to true
   */
  useEffect(() => {
    getAddresses(1, user?.tenant_info?.tenant_id, 'TENANT');
    getTenants(1, '', true, '', '', '', user?.tenant_info?.tenant_id);
    getTenantsConfiguration(user?.tenant_info?.tenant_id);
    setIsUserReady(true);
  }, []);

  /**
   * Updates user profile information based on tenants data on change
   */
  useEffect(() => {
    const tenantQRCode = { thumbUrl: tenants?.data?.[0]?.qr_code };

    setEmail(tenants?.data?.[0]?.email?.split(','));
    setCountryCode(String(tenants?.data?.[0]?.dial_code) || Helpers.getDialCode(user?.tenant_info?.country_code));
    setPhone(tenants?.data?.[0]?.mobile);
    setGst(tenants?.data?.[0]?.gst_number);
    setBranchCode(tenants?.data?.[0]?.branch_code);
    setBillingAddress(tenants?.data?.[0]?.default_billing_address_info);
    setShippingAddress(tenants?.data?.[0]?.default_shipping_address_info);
    setCompanyName(tenants?.data?.[0]?.tenant_name);
    setCompanyLegalName(tenants?.data?.[0]?.legal_name);
    setDefaultProductionDept(tenants?.data?.[0]?.default_department_for_production);
    setDefaultRmDept(tenants?.data?.[0]?.default_department_for_rm);
    setDefaultBpDept(tenants?.data?.[0]?.default_department_for_bp);
    setDefaultFgDept(tenants?.data?.[0]?.default_department_for_fg);
    setDefaultSalesDept(tenants?.data?.[0]?.default_department_for_sales);
    setBankDetails(tenants?.data?.[0]?.bank_details);
    setQRCode(tenants?.data?.[0]?.qr_code ? [tenantQRCode] : []);
    setEmailName(tenants?.data?.[0]?.display_name_in_email);
    setCIData(tenants?.data?.[0]?.identification_number?.map((item) => ({ ...item, key: uuidv4() })) || [{
      identification_name: 'GSTIN',
      identification_number: '',
      is_printable: false,
    },]);
  }, [tenants]);

  /**
   * Updates UI based on tenantsConfiguration data on change
   */
  useEffect(() => {
    const response = { thumbUrl: tenantsConfiguration?.data?.[0]?.logo_base_64 };
    if (tenantsConfiguration?.data?.[0]?.po_doc_primary_colour) {
      setColor(tenantsConfiguration?.data?.[0]?.po_doc_primary_colour);
    }
    setFileList(tenantsConfiguration?.data?.[0]?.logo_base_64 ? [response] : []);
    setDefaultTerms(tenantsConfiguration?.data?.[0]?.default_t_and_c);
    setEntityConfiguration(tenantsConfiguration?.data?.[0]?.config)
  }, [tenantsConfiguration]);

  const isCIDataValid = () => {
    for (let i = 0; i < ciData.length; i++) {
      if (!ciData[i].identification_name || !ciData[i].identification_number) {
        return false;
      }
    }

    return true;
  }

  /**
   * Handles profile update form submission
   */
  const handleUpdateProfile = () => {
    setFormSubmitted(true);
    if (isCIDataValid() && companyName && companyLegalName && email.map((item) => Helpers.validateEmail(item))?.length === email?.length
      && Helpers.validatePhoneNumber(phone)
      && shippingAddress?.address_id && billingAddress?.address_id && Helpers.validateGstNumber(gst) && branchCode && emailName.trim()) {
      const payload = {
        // Payload object for updating tenant information
        tenant_id: user?.tenant_info?.tenant_id,
        tenant_name: companyName,
        legal_name: companyLegalName,
        org_id: user?.tenant_info?.org_id,
        description: '',
        email: email?.join(','),
        dial_code: countryCode,
        mobile: phone,
        is_active: true,
        gst_number: gst,
        branch_code: branchCode,
        logo: null,
        created_by: null,
        default_shipping_address: shippingAddress?.address_id,
        default_billing_address: billingAddress?.address_id,
        default_department_for_production: defaultProductionDept,
        default_department_for_sales: defaultSalesDept,
        default_department_for_rm: defaultRmDept,
        default_department_for_fg: defaultFgDept,
        default_department_for_bp: defaultBpDept,
        bank_details: bankDetails,
        qr_code: qrCode[0]?.response?.response?.location
        ? qrCode[0]?.response?.response?.location
        : (qrCode[0]?.thumbUrl ? qrCode[0]?.thumbUrl : ''),
        identification_number: ciData,
      };
      const updateConfigurationPayload = {
        // Payload object for updating tenant configuration
        tenant_id: user?.tenant_info?.tenant_id,
        logo_base_64: fileList[0]?.response?.response?.location
          ? fileList[0]?.response?.response?.location
          : (fileList[0]?.thumbUrl ? fileList[0]?.thumbUrl : ''),
        po_doc_primary_colour: color,
        po_doc_secondary_colour: color,
        tenant_configuration_id: tenantsConfiguration?.data?.[0]?.tenant_configuration_id,
        default_t_and_c: global.isBlankString(defaultTerms) ? '' : defaultTerms,
        config: entityConfiguration,
        display_name_in_email: emailName,
      };
      updateTenant(payload, () => {
        setIsUserReady(false);
        updateTenantConfiguration(updateConfigurationPayload,
          () => {
            // Re-fetch data after update
            getTenantsConfiguration(user?.tenant_info?.tenant_id);
            getTenants(1, '', true, '', '', '', user?.tenant_info?.tenant_id);
            getUserProfile();
          });
      });
    }
  };

  const handleDelete = (key) => {
    const copyCIData = ciData?.filter((item) => item?.key !== key);
    setCIData(copyCIData)
  };

  const getColumns = () => {
    const columns = [
      {
        title: 'Identification Name',
        render: (record) => {
          return (
            <H3FormInput
              value={record?.identification_name}
              type="text"
              // containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName={(formSubmitted && (!record?.identification_name)) ? 'orgFormInputError' : 'orgFormInput border-less'}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(ciData));
                for (let i = 0; i < copyData?.length; i++) {
                  if (copyData[i]?.key === record?.key) {
                    copyData[i].identification_name = event.target.value;
                  }
                }
                setCIData(copyData);
              }}
              disabled={getTenantsLoading || getTenantsConfigurationLoading}
            />
          )
        }
      },
      {
        title: 'Identification Number',
        render: (record) => {
          return (
            <H3FormInput
              value={record?.identification_number}
              type="text"
              // containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName={(formSubmitted && (!record?.identification_number)) ? 'orgFormInputError' : 'orgFormInput border-less'}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(ciData));
                for (let i = 0; i < copyData?.length; i++) {
                  if (copyData[i]?.key === record?.key) {
                    copyData[i].identification_number = event.target.value;
                  }
                }
                setCIData(copyData);
              }}
              disabled={getTenantsLoading || getTenantsConfigurationLoading}
            />
          )
        }
      },
      {
        title: 'Is Printable',
        render: (record) => {
          return (
            <div>
              <Checkbox
                checked={record?.is_printable}
                onChange={(event) => {
                  const copyData = JSON.parse(JSON.stringify(ciData));
                  for (let i = 0; i < copyData?.length; i++) {
                    if (copyData[i]?.key === record?.key) {
                      copyData[i].is_printable = event.target.checked;
                    }
                  }
                  setCIData(copyData);
                }}
                disabled={getTenantsLoading || getTenantsConfigurationLoading}
              />
            </div>
          )
        },
      },
      {
        title: '',
        width: '40px',
        render: (text, record) => (
          <Fragment>
            <div className="delete-line-button" onClick={() => handleDelete(record.key)}>
              <CloseOutlined />
            </div>
          </Fragment>
        ),
      },
    ];

    return columns;
  }

  const addNewIdentificationRow = () => {
    const copyCIData = JSON.parse(JSON.stringify(ciData));
    copyCIData.push({
      key: uuidv4(),
      identification_name: '',
      identification_number: '',
      is_printable: false,
    });
    setCIData(copyCIData);
  }

  const inventoryConfig = user?.tenant_info?.inventory_config;
  const departmentLevelStock = inventoryConfig?.settings?.department_level_stock;

  const countryCodeOptions = CountryCodes?.map((item) => ({
    label: `${item?.flag} +${item?.dial_code}`,
    value: item?.dial_code,
    key: item?.name,
  }));
  
  const colorOptions = colorConfig?.map((item) => ({
    value: item.color,
    key: item.color,
    label: (
      <div className="profile-color-option">
        <div
          style={{ backgroundColor: item.color }}
          className="profile-color-option__swatch"
        />
        <H3Text text={item?.name} className="profile-color-option__color" />
      </div>
    ),
  }));
  
  return (
    <Fragment>
      {/* Address Drawer component for managing addresses */}
      <Drawer
        open={showAddressDrawer}
        onClose={() => {
          setShowAddressDrawer(false);
          setSelectedAddressType('');
        }}
        width="360"
        destroyOnClose
      >
        <AddressSelector
          // Props for AddressSelector component
          title={selectedAddressType === 'SHIPPING' ? 'Shipping Address' : 'Billing Address'}
          addressType="TENANT"
          selectedAddressId={selectedAddressType === 'SHIPPING' ? shippingAddress?.address_id : billingAddress?.address_id}
          onAddressChange={(address) => {
            if (selectedAddressType === 'BILLING') {
              setBillingAddress(address);
              setShowAddressDrawer(false);
            } else {
              setShippingAddress(address);
              setShowAddressDrawer(false);
            }
          }}
          onAddressUpdate={() => { }}
          entityType="TENANT"
          entityId={user?.tenant_info?.tenant_id}
          tenantId={user?.tenant_info?.tenant_id}
        />
      </Drawer>

      {/* Loading indicators while fetching data */}
      {(getTenantsLoading || getTenantsConfigurationLoading) && (
        <div className="ant-row">
          <div className="ant-col-md-17">
            <div className="ant-row">
              {[1, 2, 3, 4, 5, 6, 7]?.map((item, index) => (
                <div key={item} className="ant-col-md-12">
                  <div className={(index % 2 === 0 ? 'orgInputContainer' : 'orgInputContainer')}>
                    <div className="loadingBlock" style={{ height: '15px', marginBottom: '6px' }} />
                    <div className="loadingBlock" style={((item === 5) || (item === 6)) ? { height: '60px' } : { height: '32px' }} />
                  </div>
                </div>
              ))}
            </div>
            <br />
            <div className="ant-row">
              {[1, 2]?.map((item, index) => (
                <div key={item} className="ant-col-md-12">
                  <div className={(index % 2 === 0 ? 'orgInputContainer' : 'orgInputContainer')}>
                    <div className="loadingBlock" style={{ height: '15px', marginBottom: '6px' }} />
                    <div className="loadingBlock" style={((item === 1)) ? { height: '100px', width: '25%' } : { height: '32px' }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* Main profile content displayed when data is loaded */}
      {(getTenantsLoading || getTenantsConfigurationLoading) ? null : (
        <div className="settings__profile-wrapper-outer">
          <div className="ant-row">
            <div className="ant-col-md-17">
              <div className="settings__profile-wrapper">
                <div className="ant-row">
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="Company Name"
                      type="text"
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      onChange={(event) => setCompanyName(event.target.value)}
                      value={companyName}
                      required
                      label="Company Name"
                      maxlength="50"
                      showError={formSubmitted && !(companyName)}
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="Legal Name"
                      type="text"
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      onChange={(event) => setCompanyLegalName(event.target.value)}
                      value={companyLegalName}
                      showError={formSubmitted && !(companyLegalName)}
                      required
                      label="Legal / Trade Name"
                      maxlength="50"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer">
                      <H3Text
                        text="Phone"
                        required
                        className="orgFormLabel"
                      />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PRZSelect
                          value={countryCode}
                          showSearch
                          filterOption={(input, option) => {
                            const { label } = option.props;
                            const { value } = option.props;
                            return (
                              label.toLowerCase().includes(input.toLowerCase())
                              || value.toLowerCase().includes(input.toLowerCase())
                            );
                          }}
                          onChange={(value) => setCountryCode(value)}
                          className={formSubmitted && !countryCode ? 'prz-select__error-border' : ''}
                          style={{
                            borderRight: 'none',
                            borderRadius: '2px',
                            height: '28px',
                            width: '100px',
                            fontSize: '13px',
                          }}
                          disabled={updateTenantLoading || getTenantsLoading || getTenantsConfigurationLoading || updateTenantConfigurationLoading}
                          options={countryCodeOptions}
                        />
                        <H3FormInput
                          name="a valid phone number"
                          type="text"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput"
                          containerClassName="phone-input"
                          placeholder=""
                          onChange={(event) => setPhone(event.target.value)}
                          value={phone}
                          disabled={updateTenantLoading || getTenantsLoading || getTenantsConfigurationLoading || updateTenantConfigurationLoading}
                          maxlength="50"
                        />
                      </div>
                      {(formSubmitted && !Helpers.validatePhoneNumber(phone)) && (
                        <div className="input-error">
                          *Please enter valid phone number
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="a valid GST number"
                      type="text"
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      onChange={(event) => setGst(event.target.value)}
                      value={gst}
                      required
                      showError={formSubmitted && !Helpers.validateGstNumber(gst)}
                      label="GST Number"
                    />
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div
                      className="orgInputContainer"
                    >
                      <label className="orgFormLabel">
                        Email
                      </label>
                      <PRZSelect
                        mode="tags"
                        value={email}
                        filterOption={false}
                        maxTagCount="responsive"
                        onChange={(value) => {
                          const emails = [];
                          for (let i = 0; i < value?.length; i++) {
                            if (Helpers.validateEmail(value[i])) {
                              emails.push(value[i]);
                            }
                          }
                          setEmail(emails);
                        }}
                      />
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <H3FormInput
                      name="a branch code"
                      type="text"
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) => setBranchCode(event.target.value)}
                      value={branchCode}
                      required
                      showError={formSubmitted && !branchCode}
                      label="Branch Code"
                      maxlength="4"
                    />
                  </div>
                  {departmentLevelStock && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <SelectDepartment
                        selectedDepartment={defaultSalesDept}
                        showSearch
                        onChange={(value) => {
                          setDefaultSalesDept(value?.tenant_department_id);
                        }}
                        tenantId={user?.tenant_info?.tenant_id}
                        containerClassName="orgInputContainer"
                        labelClassName="orgFormLabel"
                        title="Default Department for Sales"
                        emptyNotAllowed
                        tenentLevelDepartment
                      />
                    </div>
                  )}
                  {departmentLevelStock && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <SelectDepartment
                        dropdownAlign={{ offset: [-6, 4] }}
                        selectedDepartment={defaultProductionDept}
                        showSearch
                        onChange={(value) => {
                          setDefaultProductionDept(value?.tenant_department_id);
                        }}
                        tenantId={user?.tenant_info?.tenant_id}
                        containerClassName="orgInputContainer "
                        labelClassName="orgFormLabel"
                        title="Default Department for Production"
                        emptyNotAllowed
                        tenentLevelDepartment
                      />
                    </div>
                  )}
                  {departmentLevelStock && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <SelectDepartment
                        selectedDepartment={defaultRmDept}
                        showSearch
                        onChange={(value) => {
                          setDefaultRmDept(value?.tenant_department_id);
                        }}
                        tenantId={user?.tenant_info?.tenant_id}
                        containerClassName="orgInputContainer "
                        labelClassName="orgFormLabel"
                        title="Default Raw Material Department"
                        emptyNotAllowed
                        tenentLevelDepartment
                      />
                    </div>
                  )}
                  {departmentLevelStock && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <SelectDepartment
                        selectedDepartment={defaultFgDept}
                        showSearch
                        onChange={(value) => {
                          setDefaultFgDept(value?.tenant_department_id);
                        }}
                        tenantId={user?.tenant_info?.tenant_id}
                        containerClassName="orgInputContainer "
                        labelClassName="orgFormLabel"
                        title="Default Finished Goods Department"
                        emptyNotAllowed
                        tenentLevelDepartment
                      />
                    </div>
                  )}
                  {departmentLevelStock && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <SelectDepartment
                        selectedDepartment={defaultBpDept}
                        showSearch
                        onChange={(value) => {
                          setDefaultBpDept(value?.tenant_department_id);
                        }}
                        tenantId={user?.tenant_info?.tenant_id}
                        containerClassName="orgInputContainer"
                        labelClassName="orgFormLabel"
                        title="Default By Products Department"
                        emptyNotAllowed
                        tenentLevelDepartment
                      />
                    </div>
                  )}
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer seller-address__filter">
                      <label className="orgFormLabel">
                        Select Default Billing Address
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <div className="settings__profile__input-row__address">
                        {billingAddress && (
                          <div className="settings__profile__input-row__address-info">
                            <div className="settings__profile__input-row__address-l1">{billingAddress?.address1}</div>
                            <div
                              className="settings__profile__input-row__address-l2"
                            >
                              {`${billingAddress?.city}, ${billingAddress?.state} ${billingAddress?.postal_code}`}
                            </div>
                          </div>
                        )}
                        {!billingAddress
                          && <H3Text text="Select address.." className="settings__profile__input-row__address-placeholder" />}
                        <div
                          className="settings__profile__input-row__address-icon"
                          onClick={() => {
                            setSelectedAddressType('BILLING');
                            setShowAddressDrawer(true);
                          }}
                        >
                          <EditFilled />
                          {' '}
                          Update
                        </div>
                      </div>
                      {formSubmitted && !billingAddress && <div className="input-error">*Please select a address</div>}
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer tenant-address__fitter">
                      <label className="orgFormLabel">
                        Select Default Shipping Address
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <div className="settings__profile__input-row__address">
                        {shippingAddress && (
                          <div className="settings__profile__input-row__address-info">
                            <div className="settings__profile__input-row__address-l1">{shippingAddress?.address1}</div>
                            <div
                              className="settings__profile__input-row__address-l2"
                            >
                              {`${shippingAddress?.city}, ${shippingAddress?.state} ${shippingAddress?.postal_code}`}
                            </div>
                          </div>
                        )}
                        {!shippingAddress
                          && <H3Text text="Select address.." className="settings__profile__input-row__address-placeholder" />}
                        <div
                          className="settings__profile__input-row__address-icon"
                          onClick={() => {
                            setSelectedAddressType('SHIPPING');
                            setShowAddressDrawer(true);
                          }}
                        >
                          <EditFilled />
                          {' '}
                          Update
                        </div>
                      </div>
                      {formSubmitted && !shippingAddress && <div className="input-error">*Please select a address</div>}
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer">
                      <label className="orgFormLabel">
                        Bank Account Details
                      </label>
                      <TextArea
                        rows={3}
                        onChange={(event) => {
                          setBankDetails(event.target.value);
                        }}
                        value={bankDetails}
                        inputClassName="orgFormInput"
                        style={{
                          width: '98%',
                          fontSize: '12px',
                        }}
                      />
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer">
                      <label className="orgFormLabel">
                        UPI QR Code
                      </label>
                      <div className="ant-col-md-12 ant-col-xs-24">
                        <div className="settings__profile-wrapper-img">
                          <Upload
                            action={constants.UPLOAD_FILE}
                            listType="picture-card"
                            fileList={qrCode}
                            onChange={(fList) => {
                              setQRCode(fList?.fileList);
                            }}
                            showUploadList={{ showPreviewIcon: false }}
                          >
                            {qrCode?.length >= 1 ? null
                              : button}
                          </Upload>
                        </div>
                      </div>
                    </div>
                  </div>
                  {true && (
                    <div className="ant-col-md-12 ant-col-xs-24">
                      <H3FormInput
                        name="a display name for emails"
                        type="text"
                        containerClassName="orgInputContainer"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(event) => setEmailName(event.target.value)}
                        value={emailName}
                        required
                        showError={formSubmitted && !emailName}
                        label="Display Email Name"
                        // maxlength="50"
                      />
                    </div>
                  )}
                </div>
                <br />

                <H3Text text="Identification Number" className="settings__profile-heading" />
                <div className="ant-row">
                  <div className="ant-col-md-18">
                    <Table
                      columns={getColumns()}
                      dataSource={ciData}
                      pagination={false}
                      size="small"
                    />
                  </div>
                </div>
                <div className="new-charge-row-button"
                  style={{ margin: "10px 0px 20px 10px" }}
                  onClick={() => addNewIdentificationRow()}
                >
                  <span className="new-charge-row-button__icon">
                    <PlusCircleFilled />
                  </span>
                  <div>Add</div>
                </div>

                <H3Text text="Brand Customization" className="settings__profile-heading" />
                <div className="ant-row">
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer">
                      <label className="orgFormLabel">
                        Your Logo
                      </label>
                      <div className="ant-col-md-12 ant-col-xs-24">
                        <div className="settings__profile-wrapper-img">

                          <H3ImageSelectorWithCrop>
                            <Upload
                              action={constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              onChange={(fList) => {
                                setFileList(fList?.fileList);
                              }}
                              showUploadList={{ showPreviewIcon: false }}
                            >
                              {fileList?.length >= 1 ? null
                                : button}
                            </Upload>
                          </H3ImageSelectorWithCrop>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12 ant-col-xs-24">
                    <div className="orgInputContainer">
                      <label className="orgFormLabel">
                        Select Brand Color
                      </label>
                      <PRZSelect
                        className="profile-color-selector"
                        value={color}
                        onChange={(value) => setColor(value)}
                        options={colorOptions}
                        showError={formSubmitted && !color}
                        errorName="a color"
                        errorClassName="input-error"
                      />
                    </div>
                  </div>
                  <div className="update-profile__footer">
                    <H3Button
                      text="Update Profile"
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      customClass="update-profile__footer-submit"
                      onClick={() => {
                        handleUpdateProfile();
                      }}
                      isLoading={updateTenantLoading && !getTenantsLoading
                        && !getTenantsConfigurationLoading && !updateTenantConfigurationLoading}
                      disabled={updateTenantLoading || getTenantsLoading
                        || getTenantsConfigurationLoading || updateTenantConfigurationLoading}
                    />
                  </div>
                </div>

                <div style={{ marginTop: '10px' }}>
                  <H3Text text="Configuration" className="settings__profile-heading" />
                  <Checkbox
                    checked={entityConfiguration?.grn?.allow_adhoc}
                    onChange={(event) => {
                      const copyData = JSON.parse(JSON.stringify(entityConfiguration));
                      copyData.grn.allow_adhoc = event.target.checked;
                      setEntityConfiguration(copyData);
                    }}
                    disabled={getTenantsLoading || getTenantsConfigurationLoading}
                  >
                    Allow user to create adhoc grn
                  </Checkbox>
                </div>

              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({
  AddressReducer, UserReducers, TenantReducers, PayoutReducers,
}) => ({
  tenantAddresses: AddressReducer.tenantAddresses,
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  getTenantsConfigurationLoading: TenantReducers.getTenantsConfigurationLoading,
  updateTenantConfigurationLoading: TenantReducers.updateTenantConfigurationLoading,
  updateTenantLoading: TenantReducers.updateTenantLoading,
  createConnectSessionLoading: PayoutReducers.createConnectSessionLoading,
  environment: UserReducers.environment,
});
const mapDispatchToProps = (dispatch) => ({
  getAddresses: (page, entityId, entityType, addressId) => dispatch(AddressActions.getAddresses(page, entityId, entityType, addressId)),
  updateTenant: (payload, callback) => dispatch(TenantActions.updateTenant(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback, tenantId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback, tenantId)),
  getTenantsSuccess: (tenents) => dispatch(TenantActions.getTenantsSuccess(tenents)),
  getTenantsConfiguration: (tenantId, callback) => dispatch(TenantActions.getTenantsConfiguration(tenantId, callback)),
  getTenantsConfigurationSuccess: (config) => dispatch(TenantActions.getTenantsConfigurationSuccess(config)),
  updateTenantConfiguration: (payload, callback) => dispatch(TenantActions.updateTenantConfiguration(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessProfile));
